import React from 'react';
import { Button } from 'primereact/button';

const ScheduleButtons = ({
  selectedToSchedule,
  onStopResumeScheduledExecution,
}) => (
  <div className='schedule-buttons-container'>
    <Button
      className='e-control e-btn e-lib e-custom mb-2 mr-2'
      onClick={() => onStopResumeScheduledExecution(false)}
    >
      Resume Selected Executions ({selectedToSchedule.length})
    </Button>
    <Button
      className='e-control e-btn e-lib e-custom mb-2'
      onClick={() => onStopResumeScheduledExecution(true)}
    >
      Pause Selected Executions ({selectedToSchedule.length})
    </Button>
  </div>
);

export default ScheduleButtons;
